"use strict";

(function($) {
    $(function() {

        $('.data-selector__item').click(function() {
            $(this).parents('.data-selector').find('.data-selector__item').removeClass('is-selected');
            $(this).addClass('is-selected');

            $(this).parents('.data-selector').find('.data-selector__item input').prop('checked','false');
            $(this).find('input').prop('checked','true');
        });

        $('.js-toggle-data-selector').click(function() {
            $(this).parents('.tab-pane').find('.data-selector--switchable').slideToggle(0);
            $(this).parents('.tab-pane').find('.data-custom').slideToggle(0);
        });

        $('.data-custom').css('height',$('.data-selector--switchable').height() + 'px');

    });
})(jQuery);
